import Controls from './Controls'
import MainForm from './MainForm'
import BdeAudit from './BdeAudit.vue'
import UiLoader from './UiLoader.vue'

export default function install(Vue = {}) {
  Vue.use(Controls)
  Vue.component('MainForm', MainForm)
  Vue.component('BdeAudit', BdeAudit)
  Vue.component('UiLoader', UiLoader)
}
